import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41f08100"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }


export default /*#__PURE__*/_defineComponent({
  name: 'BaseModal',
  props: {
    fromBottom: { type: Boolean },
    fromBottomHalf: { type: Boolean },
    fromBankList: { type: Boolean },
    noBackground: { type: Boolean },
    signature: { type: Boolean },
    agreement: { type: Boolean },
    isFull: { type: Boolean },
    isFullNoPadding: { type: Boolean }
  },
  emits: ["click_overlay"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["contents", {
          bottom: __props.fromBottom,
          'bottom-half': __props.fromBottomHalf,
          bank: __props.fromBankList,
          'no-background': __props.noBackground,
          signature: __props.signature,
          agreement: __props.agreement,
          full: __props.isFull,
          'full-no-padding': __props.isFullNoPadding
        }])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2),
      _createElementVNode("div", {
        class: "overlay",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click_overlay')))
      })
    ])
  ]))
}
}

})